import { StatefulTooltip } from 'baseui/tooltip';
import { fontFamily } from 'common/styles/styles.typography';
import { themedStyled } from 'common/styles/styletron.theme';
import Text from 'components/elements/text';

interface Props {
  value: string;
}

export default function GuestName(props: Props) {
  const name = props.value.split(', ');
  return (
    <>
      <StatefulTooltip
        content={() => (
          <>
            {name.map((val, idx) => (
              <Text key={idx} variant="LabelSmall">
                {val}
              </Text>
            ))}
          </>
        )}
        overrides={{
          Body: {
            style: {
              zIndex: 10,
            },
          },
          Inner: {
            style: {
              backgroundColor: 'white',
            },
          },
        }}
      >
        <StyledInput value={props.value} />
      </StatefulTooltip>
    </>
  );
}

const StyledInput = themedStyled('input', ({ $theme }) => ({
  border: 'none',
  padding: '4px',
  height: '100%',
  width: '100%',
  fontSize: '16px',
  backgroundColor: 'transparent',
  fontFamily,
  ':disabled': {
    color: 'black',
  },
}));
